import axios from 'axios';
import { PrivilegeRoot } from 'Interface/privilege';
import { useQuery } from 'react-query';
import { baseUrl, tenant } from 'Shared/BaseUrl';

export default function useMyPrivilege(onSuccess: (data: PrivilegeRoot) => void) {


    return useQuery(
        ['myPrivilege'],
        () => axios.get(baseUrl + `auth/my-privileges`, {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("ebs-client-token"),
                'X-Tenant': tenant,
            }
        }),
        {
            onSuccess: (data: PrivilegeRoot) => {
                onSuccess(data)
            }
        }
    )


}